module.exports = __webpack_public_path__ + "img/__icon_CYSTERNA_SILOS.43f3b533.svg";